import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f4cdced"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Push Notifications", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, " AskNicely wants to send you Push Notifications to keep you updated about new Notices and Customer Feedback. ", -1))
const _hoisted_4 = { class: "confirm-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        show: _ctx.show,
        width: "280px",
        vanilla: "",
        "has-close": "",
        top: 10,
        close: _ctx.onClose,
        class: "request-container"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_BaseButton, {
                class: "white",
                full: "",
                click: _ctx.onClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Turn on Notifications")
                ], undefined, true),
                _: 1
              }, 8, ["click"])
            ])
          ])
        ], undefined, true),
        _: 1
      }, 8, ["show", "close"]))
    : _createCommentVNode("", true)
}